<div *ngIf="!userSaveSuccess">
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="br-section-wrapper">

        <div class="form-group formWrapper">
          <div class="row searchWrapper">
            <input type="text" class="form-control height-27" style="width: 97px; margin-left:35px; margin-top: 2%;"
              placeholder="Search.." [(ngModel)]="searchText" (keyup.enter)="searchMethod()" />
            <span style="padding: 7px;
              margin-left: -3px;
              margin-top: 2%;
              height: 28px !important;
              border-radius: 3px;
              cursor: pointer;
              color: #fff;
              background-color: #7cacd7;" (click)="searchMethod()"> <i class="fa fa-search"
                aria-hidden="true"></i></span>
          </div>
          <div class="align-items-center marTop30">
            <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
              <nav class="" aria-label="Page navigation example text-center">
                <div class="text-center">
                  <div class="pagination row">
                    <div class="page-item marLeft17" (click)="nextBtnClick(-1)">
                      <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button"
                        [class.disabled]="page<=1">
                        < </a>
                    </div>
                    <div class="page-item marLeftNot42"><a href="javascript:void(0)" style="height: 33px;">
                        <p style="margin-top: 0px;">
                          <input type="text" (change)="searchMethod()" [(ngModel)]="page"
                            class="w-25 borderRadius5 marTop2"> / <b>{{((users?.totalRecords / size)+1) | number:
                            '1.0-0'}}</b>
                          <br>
                          <b>Page</b>
                        </p>
                      </a>
                    </div>
                    <div class="page-item marLeftNot42"><a class="page-link right-traverse borderRadius5 button"
                        href="javascript:void(0)" (click)="nextBtnClick(+1)"> >
                      </a></div>
                    <div class="page-item marLeftNot42"><a href="javascript:void(0)" style="height: 33px;">
                        <p style="margin-top: 0px;">
                          <input type="text" (change)="searchMethod()" class="w-25 borderRadius5 marTop2"
                            [(ngModel)]="size">
                          <br>
                          <b>Size</b>
                        </p>
                      </a></div>

                    <div class="page-item marLeftNot20 great-info">
                      Showing {{users?.users?.length}} of {{users?.totalRecords}} users <br>
                      Page {{(users?.pageNo)+1}} of {{((users?.totalRecords / size)+1) | number: '1.0-0'}} <br>
                    </div>

                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>

        <div class="table-responsive padding" *ngIf="!!users">
          <table id=" " class="table table-insurance-inner ">
            <thead class="header-user">
              <tr>
                <th class="wd-15p th-pd">User Name</th>
                <th class="wd-15p th-pd">First Name</th>
                <th class="wd-30p th-pd">Last Name</th>
                <th class="wd-30p th-pd">Active</th>
                <th class="wd-5p th-pd">GPS Enabled</th>
                <th class="wd-15p th-pd">WEB Enabled</th>
                <th class="wd-15p th-pd">Tenant</th>
                <th class="wd-15p th-pd">Role</th>
                <th class="wd-30p th-pd">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr class="" *ngFor="let item of users.users">
                <td>{{item.email}}</td>
                <td>{{item.firstName}}</td>
                <td>{{item.lastName}}</td>
                <td><i *ngIf="item.active" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.active"
                    style="color: #cc2929" class="fa fa-close"></i></td>
                <td><i *ngIf="item.gpsEnabled" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.gpsEnabled"
                    style="color: #cc2929" class="fa fa-close"></i></td>
                <td><i *ngIf="item.webEnabled" style="color: green" class="fa fa-check"></i> <i *ngIf="!item.webEnabled"
                    style="color: #cc2929" class="fa fa-close"></i></td>
                <td>{{item?.tenant?.tenantName}}</td>
                <td>{{item?.role?.role}}</td>
                <td>
                  <!-- <a href="javascript:void(0)"
                    ><i
                      class="fa fa-ban drug-ins-action"
                      aria-hidden="true"
                      data-toggle="modal"
                      data-target="#myModal"
                      (click)="selectRecord(item)"
                    ></i
                  ></a> -->
                  <a href="javascript:void(0)"><i class="fa fa-pencil drug-ins-action button-edit" aria-hidden="true"
                      data-toggle="modal" data-target="#addUserSelector" (click)="editUser(item)"></i></a>
                  <a href="javascript:void(0)" data-toggle="modal" data-target="#deleteConfirmation"><i
                      style="color: #c73131" class="fa fa-trash drug-ins-action marLeft5 button-delete"
                      aria-hidden="true" (click)="selectRecord(item)"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="align-items-center marTopNot30">
          <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
            <nav class="" aria-label="Page navigation example text-center">
              <div class="text-center">
                <div class="pagination row">
                  <div class="page-item marLeft17" (click)="nextBtnClick(-1)">
                    <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button"
                      [class.disabled]="page<=1">
                      <i class="fa fa-angle-left"></i> </a>
                  </div>
                  <div class="page-item marLeftNot42"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                        <input type="text" (change)="searchMethod()" [(ngModel)]="page"
                          class="w-25 borderRadius5 marTop2"> / <b>{{((users?.totalRecords / size)+1) | number:
                          '1.0-0'}}</b>
                        <br>
                        <b>Page</b>
                      </p>

                    </a></div>
                  <div class="page-item marLeftNot42"><a class="page-link right-traverse borderRadius5 button"
                      href="javascript:void(0)" (click)="nextBtnClick(+1)"> >
                    </a></div>
                  <div class="page-item marLeftNot42"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                        <input type="text" (change)="searchMethod()" class="w-25 borderRadius5 marTop2"
                          [(ngModel)]="size">
                        <br>
                        <b>Size</b>
                      </p>
                    </a></div>
                </div>
              </div>
            </nav>
          </div>
        </div>

      </div>

    </div>
    <!-- <app-footer></app-footer> -->

  </div>


  <!-- Floating add definition btn -->
  <button class="btn-floating-action" data-toggle="modal" data-target="#addUserSelector" (click)="setUserObj();">
    <span class="fa fa-plus"></span>
    <span class="action-tooltip text-500">Add User</span>
  </button>


  <div class="modal fade" id="addUserSelector" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document" style="min-width: 120vh;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{isEdituser ? 'Edit': 'Add'}} User</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">

              <div class="row form-group">
                <div class="col-md-3">
                  <label>User Id</label>
                </div>
                <div class="col-md-9">
                  <input type="text" class="form-control" [(ngModel)]="dataObj.email" />
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-3">
                  <label>First Name</label>
                </div>
                <div class="col-md-9">
                  <input type="text" class="form-control" [(ngModel)]="dataObj.firstName" />
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-3">
                  <label>Last Name</label>
                </div>
                <div class="col-md-9">
                  <input type="text" class="form-control" [(ngModel)]="dataObj.lastName" />
                </div>
              </div>


              <div class="row form-group">
                <div class="col-md-12">
                  <div class="nurse_input past_input systemic_in">
                    <input type="checkbox" id="eh0000-option" name="selector_h" [(ngModel)]="dataObj.active" />
                    <label for="eh0000-option">&nbsp;&nbsp;&nbsp;Active</label>
                  </div>
                </div>

                <div>
                  <div class="col-md-12">
                    <div class="nurse_input past_input systemic_in">
                      <input type="checkbox" id="eh0000-option-web" name="selector_hweb"
                        [(ngModel)]="dataObj.webEnabled" />
                      <label for="eh0000-option-web">&nbsp;&nbsp;&nbsp;Web Enabled</label>
                    </div>
                  </div>
                </div>

              </div>


            </div>


            <div class="col-md-6">

              <div class="row form-group">
                <div class="col-md-3">
                  <label>Tenant</label>
                </div>
                <div class="col-md-9">
                  <select [(ngModel)]="dataObj.tenant" class="form-control" [compareWith]="byId">
                    <option *ngFor="let tenant of users?users.tenants:''" [ngValue]="tenant">
                      {{tenant?.scac}} || --> {{tenant ? tenant.tenantId: ''}} : {{tenant ? tenant.tenantName : ''}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-3">
                  <label>Role</label>
                </div>
                <div class="col-md-9">
                  <select [(ngModel)]="dataObj.role" class="form-control" [compareWith]="byRoleId">
                    <option *ngFor="let role of users?users.roles:[]" [ngValue]="role">
                      {{role ? role.roleId: ''}} : {{role.role}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-3">
                  <label>Password</label>
                </div>
                <div class="col-md-9">
                  <input type="password" class="form-control" [(ngModel)]="dataObj.password" />
                </div>
              </div>

              <div class="row form-group">
                <div class="col-md-12">
                  <div class="nurse_input past_input systemic_in">
                    <input type="checkbox" id="eh0000-option-gps" name="selector_h_gps"
                      [(ngModel)]="dataObj.gpsEnabled" />
                    <label for="eh0000-option-gps">&nbsp;&nbsp;&nbsp;GPS Enabled</label>
                  </div>
                </div>

                <div>
                  <div class="col-md-12">
                    <div class="nurse_input past_input systemic_in">
                      <input type="checkbox" id="eh0000-option-showinvoice" name="selector_h_showinvoice"
                        [(ngModel)]="dataObj.showInvoices" />
                      <label for="eh0000-option-showinvoice">&nbsp;&nbsp;&nbsp;Show Invoices</label>
                    </div>
                  </div>
                </div>

              </div>



            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="saveUserDetails()">Save</button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="modal fade" id="deleteConfirmation" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Delete Confirmation</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <span style="margin-left: 20px;">Are you sure you want to delete {{selectedUser?.email}} ?</span>
            <span style="margin-left: 20px; color: red; font-size: 13px; font-weight: bold;">
              Note: Delete feature is disabled for now to avoid any data loss.
              If you want to delete any record please contact system Admin</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" disabled class="btn btn-danger" data-dismiss="modal"
            (click)="deleteUser()">Delete</button>
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>

        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="userSaveSuccess" class="alert alert-success">
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="br-section-wrapper" style="padding: 20px;">
        <div style="font-size: 19px;"><strong>Success!</strong> User details saved successfully. 
          <i class="fa fa-check-circle"></i>
          <button type="button" class="button-delete-close" (click)="userSaveSuccess = false; getUsers();">
            <span aria-hidden="true">Close &times;</span>
          </button>
        </div>
        <hr>
        <div *ngIf="savedUser" class="saved-user-info">
          <strong>Saved User Details:</strong>
          <pre>{{ savedUser | json }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>